import { Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => (
	<CssColumnGrid columns={3}>
		<Text semiBold text="normal" />
		<Text semiBold text="semiBold" />
		<Text semiBold text="bold" />
		<Text text="The quick brown fox jumps over the lazy dog!" />
		<Text semiBold text="The quick brown fox jumps over the lazy dog!" />
		<Text bold text="The quick brown fox jumps over the lazy dog!" />
	</CssColumnGrid>
);
